import * as Yup from 'yup';

// SignUp Schema
export const SignUpSchema = (step = 1) => {
  let schema = Yup.object().shape({
    firstName: Yup.string().required('First Name is Required'),
    lastName: Yup.string().required('Last Name is Required'),
    email: Yup.string().email('Invalid Email Address').required('Email Required'),
    isAdult: Yup.boolean().oneOf([true], 'Must Be an Adult'),
    password: Yup.string()
      .required('Password is required')
      .matches(
        /^(?=.*[A-Z])(?=.*\d).{8,}$/,
        'Password Must Be At Least 8 Characters Long, Include At Least One Uppercase Letter, And One Numeric Digit'
      ),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password')], 'Passwords Must Match')
      .required('Confirm Password Required')
  });

  if (step === 2) {
    schema = schema.shape({
      terms: Yup.boolean().oneOf([true], 'Must Accept Terms')
    });
  }

  return schema;
};

// SignUp via Google Schema
export const SignUpViaGoogleSchema = () => {
  return Yup.object().shape({
    terms: Yup.boolean().oneOf([true], 'Must Accept Terms')
  });
};

// LogIn Schema
export const LogInSchema = () => {
  return Yup.object().shape({
    email: Yup.string().email('Invalid Email Address').required('Email Required'),
    password: Yup.string().required('Password Required').min(8, 'Must Be At Least 8 Characters')
  });
};

// LogIn Student Schema
export const StudentLogInSchema = () => {
  return Yup.object().shape({
    username: Yup.string().required('Username Required'),
    password: Yup.string().required('Password Required').min(8, 'Must Be At Least 8 Characters')
  });
};
